import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { DimensionInformationEnum, TypeSignDimensionEnum } from 'src/enumerators';
import { HorizontalSignalingDimensionSettingTypeEnum, HorizontalWithHeight, HorizontalWithoutHeight } from 'src/enumerators/signaling-type.enum';
import { SettingsDimesionHorizontalData, SettingsDimesionTrafficData } from 'src/models/settings';

@Component({
  selector: 'app-dimension-card',
  templateUrl: './dimension-card.component.html',
  styleUrls: ['./dimension-card.component.css']
})
export class DimensionCardComponent implements OnInit, OnChanges {
  @ViewChildren(PopoverDirective) popovers: QueryList<PopoverDirective>;
  @Input() typeDimension: TypeSignDimensionEnum;
  @Input() dimensionTrafficList: SettingsDimesionTrafficData[] = [];
  @Input() dimensionHorizontalList: SettingsDimesionHorizontalData[] = [];
  @Output() updateDimensionSettings = new EventEmitter<{ trafficList: SettingsDimesionTrafficData[], horizontalList: SettingsDimesionHorizontalData[], trafficType: TypeSignDimensionEnum }>();

  typeSignDimensionEnum = TypeSignDimensionEnum;
  dimensionInformationEnum = DimensionInformationEnum;
  horizontalSignalingDimensionSettingTypeEnum = HorizontalSignalingDimensionSettingTypeEnum;
  horizontalWithoutHeight = Object.values(HorizontalWithoutHeight);
  horizontalWithHeight = Object.values(HorizontalWithHeight);
  accordionOpen = false;

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.popovers.forEach((popover: PopoverDirective) => {
        popover.onShown.subscribe(() => {
          this.popovers.filter((p) => p !== popover).forEach((p) => p.hide());
        });
      });
    }, 2000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dimensionTrafficList = changes?.dimensionTrafficList?.currentValue.filter(i => i.shape == this.typeDimension);
  }

  openAccordionGroup(event: boolean) {
    this.accordionOpen = event;
  }

  // Fecha o accordion (usado após salvar as dimensões)
  closeAccordion() {
    this.accordionOpen = false;
  }

  newDimension(typeSignDimension: TypeSignDimensionEnum, type: DimensionInformationEnum) {
    if (typeSignDimension == TypeSignDimensionEnum.Horizontal) {
      if (type == DimensionInformationEnum.Envolvente)
        this.dimensionHorizontalList.push(new SettingsDimesionHorizontalData({
          type: HorizontalSignalingDimensionSettingTypeEnum.WithoutHeight,
        }))
      else
        this.dimensionHorizontalList.push(new SettingsDimesionHorizontalData({
          type: HorizontalSignalingDimensionSettingTypeEnum.WithHeight,
        }))

    } else {
      this.dimensionTrafficList.push(new SettingsDimesionTrafficData({
        shape: typeSignDimension,
        dimensionType: type,
      }))

    }
    this.updateDimensionSettings.emit({ trafficList: this.dimensionTrafficList, horizontalList: this.dimensionHorizontalList, trafficType: this.typeDimension })
  }

  updateDimensionValues(event) {
    this.updateDimensionSettings.emit({ trafficList: this.dimensionTrafficList, horizontalList: this.dimensionHorizontalList, trafficType: this.typeDimension })
  }

  filterTrafficList(list: SettingsDimesionTrafficData[], filterType) {
    return list?.filter(i => i.dimensionType == filterType);
  }

  filterHorizontalList(list: SettingsDimesionHorizontalData[], filterType) {
    return list?.filter(i => i.type == filterType);
  }

  removeDimensionSetting(item, type) {
    let index;

    if (type == 'horizontal') {
      index = this.dimensionHorizontalList.findIndex(d => d === item);
      this.dimensionHorizontalList.splice(index, 1);
    }

    else {
      index = this.dimensionTrafficList.findIndex(d => d === item);
      this.dimensionTrafficList.splice(index, 1);
    }

    this.updateDimensionSettings.emit({ trafficList: this.dimensionTrafficList, horizontalList: this.dimensionHorizontalList, trafficType: this.typeDimension })

  }
}
